import script from "./luckManager.vue?vue&type=script&lang=ts&setup=true"
export * from "./luckManager.vue?vue&type=script&lang=ts&setup=true"

import "./luckManager.vue?vue&type=style&index=0&id=7be3c9b4&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be3c9b4"]])

export default __exports__